/**
 * Aspecto de la cabecera de cada columna del tablero del CRM según el color de
 * la etapa.
 *
 * El color lo elige cada empresa en `settings.customerStates[].color`. Las
 * clases van escritas enteras a propósito: Tailwind sólo genera las que
 * encuentra literales en el código, así que `bg-${color}-soft` no existiría en
 * el CSS final. Este mapa lo comparten el tablero (`pages/admin/crm`) y el
 * editor de etapas (`layers/CustomerStatesEditor`).
 */
export const KANBAN_COLUMN_STYLES: Record<string, { cabecera: string; barra: string; numero: string }> = {
  default: { cabecera: 'bg-surface-muted/60', barra: 'bg-foreground-subtle/40', numero: 'text-foreground-subtle' },
  primary: { cabecera: 'bg-primary-soft/50', barra: 'bg-primary', numero: 'text-primary' },
  info: { cabecera: 'bg-info-soft/50', barra: 'bg-info', numero: 'text-info' },
  success: { cabecera: 'bg-success-soft/50', barra: 'bg-success', numero: 'text-success' },
  warning: { cabecera: 'bg-warning-soft/50', barra: 'bg-warning', numero: 'text-warning' },
  danger: { cabecera: 'bg-danger-soft/50', barra: 'bg-danger', numero: 'text-danger' }
}

/** Colores de columna disponibles para elegir una etapa (orden del swatch). */
export const KANBAN_STAGE_COLORS: string[] = ['default', 'primary', 'info', 'success', 'warning', 'danger']

/** Estilo de una columna dado el color de la etapa; cae a `default` si no existe. */
export const kanbanColumnStyle = (color?: string) => KANBAN_COLUMN_STYLES[color ?? 'default'] ?? KANBAN_COLUMN_STYLES.default
